import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import SearchBox from 'components/site/SearchBox';
import CustomerSearchStore from 'stores/CustomerSearchStore';
import CustomersActionCreators from 'actions/CustomersActionCreators';
import { debounce } from 'lodash';
import { titleize } from 'underscore.string';
import { withTranslation } from 'react-i18next';
import { renderItem } from './CustomerSearchItem';
function getCustomerValue(item) {
    return titleize(item.optimized_name);
}
function getCustomerName(item) {
    switch (item.type) {
        case 'Partner':
        case 'Carrier':
            return item.name;
        case 'Shipper':
        case 'Vendor':
            return item.company_name;
        default:
            return `${item.first_name} ${item.last_name}`;
    }
}
const USER_QUERY_TAGS = {
    'Third Party Carrier': 'third_party_carrier',
};
class CustomerSearch extends Component {
    constructor(props) {
        super(props);
        this.handleCustomerStoreChange = () => {
            const customers = CustomerSearchStore.getSearchResults();
            customers.sort((a, b) => {
                // Most shippers have undefined
                if ((a.authorized === true || a.authorized === undefined) &&
                    b.authorized === false) {
                    return -1;
                }
                if (a.authorized === false &&
                    (b.authorized === true || b.authorized === undefined)) {
                    return 1;
                }
                return getCustomerName(a).localeCompare(getCustomerName(b));
            });
            this.setState({ customers, isLoading: false });
        };
        this.handleChange = (nGram) => {
            if (!nGram || nGram.length <= 2) {
                CustomerSearchStore.clearSearchResults();
            }
            this.setState({ isLoading: true });
        };
        this.handleUserSelect = (value, item) => {
            const rejectSelection = this.props.assignField === true &&
                this.isCarrierOrDriver(item) &&
                !item.authorized;
            if (rejectSelection && !this.props.allowUnauthorizedCarriers) {
                return;
            }
            CustomerSearchStore.clearSearchResults();
            this.props.onSelect(value, item);
            const filteredValue = (value || '').trim();
            if (filteredValue) {
                const value = this.props.clearOnSelect ? '' : item.name;
                this.setState({
                    selectedItem: value,
                });
            }
        };
        this.onFocus = () => {
            if (this.props.clearOnFocus) {
                CustomerSearchStore.clearSearchResults();
            }
        };
        this.state = {
            customers: [],
            selectedItem: '',
            isLoading: false,
        };
        this.handleSearch = debounce(this.handleSearch, 500);
    }
    componentDidMount() {
        CustomerSearchStore.addChangeListener(this.handleCustomerStoreChange);
    }
    componentWillUnmount() {
        CustomerSearchStore.removeChangeListener(this.handleCustomerStoreChange);
        CustomerSearchStore.clearSearchResults();
    }
    clear() {
        this.setState({ customers: [] });
    }
    handleSearch(nGram) {
        const { type: customerType, selectFields, authorizedOnly, userTag, } = this.props;
        const params = {
            name: nGram,
            selectFields,
            authorizedOnly,
        };
        if (customerType) {
            params.customerType = customerType;
        }
        if (userTag) {
            const tag = USER_QUERY_TAGS[userTag];
            if (tag) {
                params.userTag = tag;
            }
        }
        CustomersActionCreators.searchCustomers(params);
    }
    isCarrierOrDriver(item) {
        return item.type === 'Driver' || item.type === 'Carrier';
    }
    render() {
        const { t } = this.props;
        return (React.createElement(SearchBox, { id: this.props.id, items: this.state.customers, clear: () => this.clear(), clearOnSelect: this.props.clearOnSelect, search: (nGram) => this.handleSearch(nGram), placeholder: this.props.placeholder || t('SEARCH_FOR_CUSTOMERS'), value: this.state.selectedItem || this.props.defaultValue, onChange: (value) => this.handleChange(value), onSelect: this.handleUserSelect, getItemValue: this.props.displayValue || getCustomerValue, menuStyle: this.props.menuStyle, renderItem: renderItem, inputStyle: this.props.inputStyle, dropdownStyle: this.props.dropdownStyle, disabled: this.props.disabled, testDataId: "customer-search", onFocus: this.onFocus, showEmptyMessage: this.props.showEmptyMessage && !this.state.isLoading, emptyMessage: this.props.emptyMessage }));
    }
}
CustomerSearch.propTypes = {
    clearOnFocus: PropTypes.bool,
    clearOnSelect: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
    type: PropTypes.string,
    authorizedOnly: PropTypes.bool,
    defaultValue: PropTypes.string,
    placeholder: PropTypes.string,
    dropdownStyle: PropTypes.object,
    selectFields: PropTypes.array,
    disabled: PropTypes.bool,
    userTag: PropTypes.string,
};
CustomerSearch.defaultProps = {
    authorizedOnly: false,
    clearOnSelect: true,
    clearOnFocus: false,
    type: '',
    dropdownStyle: {},
    selectFields: [],
};
export default withRouter(withTranslation()(CustomerSearch));
